import { useCreateProductPurchase } from 'api-hooks/product/order';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import ProductOrderForm from './components/form';
import { ProductPurchaseFormType } from './components/form-type';

export type ProductOrderCreateParams = {
  defaultValues?: ProductPurchaseFormType;
};

export default function ProductOrderCreate(
  props: NavigationProps<NavigationRoutes.ProductPurchasesCreate>,
) {
  const { mutateAsync, error } = useCreateProductPurchase();
  const onResolve = useApprovalableEdit('product-purchases');

  return (
    <>
      <ProductOrderForm
        {...props}
        renderError={
          !!error &&
          !!error.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => error.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )
        }
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
